import { fetchFlexmonsterLicenseKey } from "./getFlexmonsterLicense";

// This returns a Promise for the config object
const getFlexmonsterConfig = async () => {
  const licenseKey = await fetchFlexmonsterLicenseKey();
  return {
    licenseKey,
  };
};

export default getFlexmonsterConfig;
